import {PaginatedResponse} from "../types/Pagination";
import {
    getMerchant,
    getMerchantDocument,
    getMerchantDocuments,
    getMerchants,
    updateMerchant,
    createMerchant,
    getMerchantDocumentsFailed,
    getMerchantDocumentsPending,
    getMerchantSelect,
    getMerchantDocumentsOffline,
    updateOfflineDocument,
    createOfflineDocument,
    getOfflineDocument,
    getMerchantCreditTransactionsApi,
    getMerchantCreditTransactionApi,
    createMerchantCreditTransactionApi,
    updateMerchantCreditTransactionApi,
    deleteMerchantCreditTransactionApi,
    deleteMerchantApi, getMerchantCreditsApi,
    getMerchantPublicDocument,
    getApiKeyForMerchant,
    createMerchantApiKey,
    updateMerchantLogo,
    getMerchantFromGsisApi, getMerchantDocumentSignatures
} from "../helpers/backend_helper";
import {MerchantInvoice} from "../types/MerchantInvoice";
import {Merchant} from "../types/Merchant";
import {DocumentOffline} from "../types/DocumentOffline";

const MerchantService = {
    fetchMerchantDocumentSignaturesPaginatedData: async (page: number, pageSize: number, query: string, selectedMerchant: string | null, startDate: string | null, endDate: string | null, selectedInvoiceType: string | null): Promise<PaginatedResponse> => {
        let params: { [key: string]: any } = {
            page,
            pageSize,
            query,
            selectedMerchant,
            startDate,
            endDate,
            selectedInvoiceType
        };

        return await getMerchantDocumentSignatures(params);
    },
    fetchMerchantDocumentsPaginatedData: async (page: number, pageSize: number, query: string, selectedMerchant: string | null, startDate: string | null, endDate: string | null, selectedInvoiceType: string | null): Promise<PaginatedResponse> => {
        let params: { [key: string]: any } = {
            page,
            pageSize,
            query,
            selectedMerchant,
            startDate,
            endDate,
            selectedInvoiceType
        };

        return await getMerchantDocuments(params);
    },
    fetchMerchantDocumentsFailedPaginatedData: async (page: number, pageSize: number, query: string, selectedMerchant: string | null, startDate: string | null, endDate: string | null, selectedInvoiceType: string | null): Promise<PaginatedResponse> => {
        let params = {
            page,
            pageSize,
            query,
            selectedMerchant,
            startDate,
            endDate,
            selectedInvoiceType
        };

        return await getMerchantDocumentsFailed(params);
    },
    fetchMerchantDocumentsPendingPaginatedData: async (page: number, pageSize: number, query: string, selectedMerchant: string | null, startDate: string | null, endDate: string | null, selectedInvoiceType: string | null): Promise<PaginatedResponse> => {
        let params = {
            page,
            pageSize,
            query,
            selectedMerchant,
            startDate,
            endDate,
            selectedInvoiceType
        };

        return await getMerchantDocumentsPending(params);
    },
    fetchMerchantDocumentsOfflinePaginatedData: async (page: number, pageSize: number, query: string, selectedMerchant: string | null, startDate: string | null, endDate: string | null, selectedInvoiceType: string | null): Promise<PaginatedResponse> => {
        let params = {
            page,
            pageSize,
            query,
            selectedMerchant,
            startDate,
            endDate,
            selectedInvoiceType
        };

        return await getMerchantDocumentsOffline(params);
    },
    fetchMerchantDocument: async (documentId: string): Promise<MerchantInvoice> => {
        return await getMerchantDocument(documentId);
    },
    fetchMerchantPublicDocument: async (documentId: string): Promise<MerchantInvoice> => {
        return await getMerchantPublicDocument(documentId);
    },
    fetchMerchantsPaginatedData: async (page: number, pageSize: number, query: string): Promise<PaginatedResponse> => {
        let params = {
            page,
            pageSize,
            query
        };

        return await getMerchants(params);
    },
    fetchMerchantSelect: async (): Promise<any> => {
        return await getMerchantSelect();
    },
    fetchMerchantData: async (merchantId: string): Promise<Merchant> => {
        return await getMerchant(merchantId);
    },
    updateMerchantData: async (merchantId: string, data: any): Promise<any> => {
        return await updateMerchant(merchantId, data);
    },
    createMerchantData: async (data: any): Promise<any> => {
        return await createMerchant(data);
    },
    fetchOfflineDocumentData: async (documentId: string): Promise<DocumentOffline> => {
        return await getOfflineDocument(documentId);
    },
    updateOfflineDocumentData: async (documentId: string, data: any): Promise<any> => {
        return await updateOfflineDocument(documentId, data);
    },
    createOfflineDocumentData: async (data: any): Promise<any> => {
        return await createOfflineDocument(data);
    },
    fetchMerchantCreditTransactions: async (page: number, pageSize: number, query: string, selectedMerchant: string | null): Promise<PaginatedResponse> => {
        let params = {
            page,
            pageSize,
            query,
            selectedMerchant
        };

        return await getMerchantCreditTransactionsApi(params);
    },
    fetchMerchantCreditTransaction: async (transactionId: string): Promise<any> => {
        return await getMerchantCreditTransactionApi(transactionId);
    },
    createMerchantCreditTransaction: async (data: any): Promise<any> => {
        return await createMerchantCreditTransactionApi(data);
    },
    updateMerchantCreditTransaction: async (transactionId: string, data: any): Promise<any> => {
        return await updateMerchantCreditTransactionApi(transactionId, data);
    },
    deleteMerchantCreditTransaction: async (transactionId: string): Promise<any> => {
        return await deleteMerchantCreditTransactionApi(transactionId);
    },
    deleteMerchant: async (transactionId: string): Promise<any> => {
        return await deleteMerchantApi(transactionId);
    },
    fetchMerchantCredits: async (merchantId: string): Promise<any> => {
        return await getMerchantCreditsApi(merchantId);
    },
    fetchMerchantApi: async (merchantId: string): Promise<any> => {
        return await getApiKeyForMerchant(merchantId);
    },
    createMerchantApiKey: async (merchantId: string): Promise<any> => {
        return await createMerchantApiKey(merchantId);
    },
    updateMerchantLogoApi: async (merchantId: string, data: any): Promise<any> => {
        return await updateMerchantLogo(merchantId, data);
    },
    fetchGsisDataForVatCredits: async (vatNumber: string): Promise<any> => {
        return await getMerchantFromGsisApi(vatNumber);
    },
};

export default MerchantService;
